// extracted by mini-css-extract-plugin
export default {"main":"AIEssaysList_main__FE6Aq","has_button":"AIEssaysList_has_button__-O9ni","no_button":"AIEssaysList_no_button__kbewg","main_partition":"AIEssaysList_main_partition__70FQE"};